import { addressesReducer } from './addresses.reducer'
export * from './addresses.types'
export * from './addresses.actions'
export * from './addresses.thunks'

export default addressesReducer
